// import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { ConsultaCPF } from '../../components/Home/components/consulta-cpf'
import { AtendimentoForms } from '../../components/Callback/atendimento-forms';

export function Consulta() {
  const [document, setDocument] = useState('')
  const [isSearch, setIsSearch] = useState(false)
  function handleSearch(label: string) {
    // if (label === 'email') {
    //   const regexEmail = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+\.([a-z]+)?$/i;
    //   const validator = regexEmail.test(document)
    // }
    setIsSearch(true)
  }

  useEffect(() => {
    setIsSearch(false)
  }, [])

  return (
    <>
      <section className=''>
        <div className="flex h-sideBar w-full mt-4 p-6 flex-col bg-[#f1f5f9]">
          {/* <h2 className='text-2xl text-primary my-4 font-bold'>Olá, seja bem-vindo ao Aciona One!</h2> */}
          <ConsultaCPF document={document} setDocument={setDocument} handleSearch={handleSearch} />

          {
            isSearch && (
              <div className="mb-2 mt-4 flex h-[80vh] w-[62%] items-center justify-center gap-2 rounded-lg bg-slate-200 px-2 py-2">
                <AtendimentoForms isConsulta />
              </div>
            )
          }
        </div>
      </section>
    </>
  );
}
